import { render } from "./PriceCodes.vue?vue&type=template&id=584f5750&scoped=true"
import script from "./PriceCodes.vue?vue&type=script&lang=js"
export * from "./PriceCodes.vue?vue&type=script&lang=js"

import "./PriceCodes.vue?vue&type=style&index=0&id=584f5750&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\caleb\\OneDrive\\Desktop\\apps\\kff_ordering_portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584f5750"]])

export default __exports__